import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Output, NgModule } from '@angular/core';
import { BehaviorSubject, Subject, forkJoin } from 'rxjs';
import { map, first, takeUntil } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import * as i2 from '@angular/forms';
import { Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as errorUtils from 'error-message-utility';
import * as i5 from 'dirty-check-store';
import { MarkCleanFormAction, MarkDirtyFormAction } from 'dirty-check-store';
import * as i1$1 from 'reference-library';
import * as i3 from 'primeng/dynamicdialog';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import * as i4 from '@ngrx/store';
import * as i7 from 'ngx-toastr';
import * as i8 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i9 from 'primeng/inputtext';
import { InputTextModule } from 'primeng/inputtext';
import * as i10 from 'primeng/button';
import { ButtonModule } from 'primeng/button';
import * as i11 from 'primeng/dropdown';
import { DropdownModule } from 'primeng/dropdown';
import { DividerModule } from 'primeng/divider';

class AddBeneficiaryOrMemberService {
    constructor(http) {
        this.http = http;
        this.saveBenMemberSubject = new BehaviorSubject({});
    }
    getFamilyRelationshipTypes() {
        return this.http.get(`/referenceLibrary/FAMRELTYP`).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
        }));
    }
    getEmailTypes() {
        return this.http.get(`/referenceLibrary/EMLTYP`).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
        }));
    }
    createBeneficiary(payload) {
        return this.http.post(`/attorney/beneficiary/create`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    createBeneficiaryFamily(benId, payload) {
        return this.http.post(`/beneficiary/${benId}/profile/family`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    getDependentList(beneficiaryId) {
        return this.http.get(`/vd/beneficiary/${beneficiaryId}/dependentDetails`).pipe(map(response => {
            return response['data'];
        }));
    }
}
AddBeneficiaryOrMemberService.ɵfac = function AddBeneficiaryOrMemberService_Factory(t) { return new (t || AddBeneficiaryOrMemberService)(i0.ɵɵinject(i1.HttpClient)); };
AddBeneficiaryOrMemberService.ɵprov = i0.ɵɵdefineInjectable({ token: AddBeneficiaryOrMemberService, factory: AddBeneficiaryOrMemberService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddBeneficiaryOrMemberService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function AddBeneficiaryOrMemberComponent_div_3_h5_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h5", 30);
    i0.ɵɵtext(1, "Add Sponsor");
    i0.ɵɵelementEnd();
} }
function AddBeneficiaryOrMemberComponent_div_3_h5_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h5", 31);
    i0.ɵɵtext(1, "Add Individual");
    i0.ɵɵelementEnd();
} }
function AddBeneficiaryOrMemberComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, AddBeneficiaryOrMemberComponent_div_3_h5_1_Template, 2, 0, "h5", 28);
    i0.ɵɵtemplate(2, AddBeneficiaryOrMemberComponent_div_3_h5_2_Template, 2, 0, "h5", 29);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.inputData.isAddingSponsor);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.inputData.isAddingSponsor);
} }
function AddBeneficiaryOrMemberComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "h5", 32);
    i0.ɵɵtext(2, "Add dependent (family member)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function AddBeneficiaryOrMemberComponent_div_16_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 34);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r8.getGlobalErrorMessages("REQUIRED"), " ");
} }
function AddBeneficiaryOrMemberComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, AddBeneficiaryOrMemberComponent_div_16_span_1_Template, 2, 1, "span", 33);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.addBenMemberForm.get("fName").errors == null ? null : ctx_r2.addBenMemberForm.get("fName").errors.required);
} }
function AddBeneficiaryOrMemberComponent_div_21_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 34);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r9.getGlobalErrorMessages("REQUIRED"), " ");
} }
function AddBeneficiaryOrMemberComponent_div_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, AddBeneficiaryOrMemberComponent_div_21_span_1_Template, 2, 1, "span", 33);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.addBenMemberForm.get("lName").errors == null ? null : ctx_r3.addBenMemberForm.get("lName").errors.required);
} }
function AddBeneficiaryOrMemberComponent_ng_container_29_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 34);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r12.getGlobalErrorMessages("REQUIRED"), " ");
} }
function AddBeneficiaryOrMemberComponent_ng_container_29_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 38);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r11 = i0.ɵɵnextContext().index;
    const ctx_r13 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate1("id", "emailPatternError", i_r11, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r13.getGlobalErrorMessages("INVALID_EMAIL"), " ");
} }
function AddBeneficiaryOrMemberComponent_ng_container_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 35);
    i0.ɵɵelement(2, "input", 36);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, AddBeneficiaryOrMemberComponent_ng_container_29_span_3_Template, 2, 1, "span", 33);
    i0.ɵɵtemplate(4, AddBeneficiaryOrMemberComponent_ng_container_29_span_4_Template, 2, 2, "span", 37);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const x_r10 = ctx.$implicit;
    const i_r11 = ctx.index;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroupName", i_r11);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "emailInput", i_r11, "");
    i0.ɵɵproperty("pattern", ctx_r4.emailPattern);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", x_r10.get("email").touched && x_r10.get("email").hasError("required"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", x_r10.get("email").touched && x_r10.get("email").hasError("pattern"));
} }
function AddBeneficiaryOrMemberComponent_div_30_div_4_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 34);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r16.getGlobalErrorMessages("REQUIRED"), " ");
} }
function AddBeneficiaryOrMemberComponent_div_30_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, AddBeneficiaryOrMemberComponent_div_30_div_4_span_1_Template, 2, 1, "span", 33);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r15.addBenMemberForm.get("relationShipType").errors == null ? null : ctx_r15.addBenMemberForm.get("relationShipType").errors.relatioShipIsRequired);
} }
function AddBeneficiaryOrMemberComponent_div_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelementStart(1, "label", 39);
    i0.ɵɵtext(2, " Relationship with the Sponsor ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "p-dropdown", 40);
    i0.ɵɵtemplate(4, AddBeneficiaryOrMemberComponent_div_30_div_4_Template, 2, 1, "div", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r5.relationShipTypes);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.addBenMemberForm.get("relationShipType").touched && ctx_r5.addBenMemberForm.get("relationShipType").invalid);
} }
class AddBeneficiaryOrMemberComponent {
    constructor(referenceLibraryService, fb, dynamicDialogRef, dynamicDialogConfig, store, guard, apiService, toast) {
        var _a;
        this.referenceLibraryService = referenceLibraryService;
        this.fb = fb;
        this.dynamicDialogRef = dynamicDialogRef;
        this.dynamicDialogConfig = dynamicDialogConfig;
        this.store = store;
        this.guard = guard;
        this.apiService = apiService;
        this.toast = toast;
        this.emailPattern = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$';
        this.formChangesSubscriptions = [];
        this.relationShipTypes = [];
        this.onSaveComplete = new EventEmitter();
        this.destroy$ = new Subject();
        this.uniqueFamilyCodes = ['FATHER', 'MOTHER', 'FIANCE', 'SPOUSE'];
        this.emailTypeList = [];
        this.inputData = this.dynamicDialogConfig.data;
        this.addBenMemberForm = this.fb.group({
            id: [0],
            companyId: [this.inputData ? (_a = this.inputData) === null || _a === void 0 ? void 0 : _a.companyId : null],
            fName: [null, Validators.required],
            mName: [null],
            lName: [null, Validators.required],
            emailContacts: this.fb.array([
                this.fb.group({
                    email: ['', [Validators.required, Validators.pattern(this.emailPattern)]],
                    id: [0],
                    type: this.fb.group({
                        code: ['PRIM'],
                        id: [null]
                    })
                })
            ]),
            relationShipType: [null, this.relationShipRequired.bind(this)],
            email: [null]
        });
    }
    ngOnInit() {
        const requestArray = [this.apiService.getFamilyRelationshipTypes(), this.apiService.getEmailTypes()];
        if (this.inputData.isAddingMember) {
            requestArray.push(this.apiService.getDependentList(this.inputData.beneficiaryId));
        }
        this.formChangesSubscriptions[0] = forkJoin(requestArray).subscribe((results) => {
            if (results && results[0]) {
                this.referenceLibraryService.translateArray(results[0], 'name')
                    .then(translated => {
                    this.relationShipTypes = translated;
                })
                    .catch(error => console.error("Translation error:", error));
            }
            if (results && results[1]) {
                this.emailTypeList = results[1];
                const emailTypeId = this.emailTypeList.find(x => x.code === 'PRIM') ? this.emailTypeList.find(x => x.code === 'PRIM').id : null;
                this.addBenMemberForm.get('emailContacts').get('0').get('type').get('id').setValue(emailTypeId);
            }
            if (results && results[2]) {
                const alreadyAddedMembersCode = [];
                results[2].forEach((element) => { alreadyAddedMembersCode.push(element.relationshipCode); });
                this.relationShipTypes = this.relationShipTypes.map((relType) => {
                    if (this.uniqueFamilyCodes.includes(relType.code) && alreadyAddedMembersCode.includes(relType.code)) {
                        relType['inactive'] = true;
                    }
                    return relType;
                });
            }
        });
        this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
        this.formChangesSubscriptions[1] = this.addBenMemberForm.valueChanges
            .subscribe(() => {
            if (this.addBenMemberForm.dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
            }
        });
        this.translet();
    }
    relationShipRequired(control) {
        if (this.inputData.isAddingMember && !control.value) {
            return { relatioShipIsRequired: true };
        }
        return null;
    }
    handleClose() {
        this.guardSubscription = this.guard.canDeactivate().pipe(first()).subscribe((response) => {
            if (response) {
                this.dynamicDialogRef.close();
            }
            else {
                return false;
            }
        });
    }
    translet() {
        setTimeout(() => {
            this.referenceLibraryService.transletConversion();
        }, 600);
    }
    saveBenMember() {
        let payload = Object.assign({}, this.addBenMemberForm.value);
        let req;
        if (this.inputData.isAddingMember) {
            delete payload.companyId;
            delete payload.email;
            payload = { family: [Object.assign({}, payload)] };
            req = this.apiService.createBeneficiaryFamily(this.inputData.beneficiaryId, payload);
        }
        else {
            payload = Object.assign(Object.assign({}, payload), { firstName: this.addBenMemberForm.value.fName, middleName: this.addBenMemberForm.value.mName, lastName: this.addBenMemberForm.value.lName, email: payload.emailContacts[0].email });
            req = this.apiService.createBeneficiary(payload);
        }
        req.pipe(takeUntil(this.destroy$)).subscribe((response) => {
            if (response) {
                this.toast.success(response.message, 'Success');
                this.apiService.saveBenMemberSubject.next({ saved: true, isAddingMember: this.inputData.isAddingMember, data: response.data });
                this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
                this.dynamicDialogRef.close();
            }
        });
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
        if (this.formChangesSubscriptions) {
            this.formChangesSubscriptions.forEach(item => { item.unsubscribe(); });
        }
        this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
    }
}
AddBeneficiaryOrMemberComponent.ɵfac = function AddBeneficiaryOrMemberComponent_Factory(t) { return new (t || AddBeneficiaryOrMemberComponent)(i0.ɵɵdirectiveInject(i1$1.ReferenceLibraryService), i0.ɵɵdirectiveInject(i2.FormBuilder), i0.ɵɵdirectiveInject(i3.DynamicDialogRef), i0.ɵɵdirectiveInject(i3.DynamicDialogConfig), i0.ɵɵdirectiveInject(i4.Store), i0.ɵɵdirectiveInject(i5.DirtyFormGuard), i0.ɵɵdirectiveInject(AddBeneficiaryOrMemberService), i0.ɵɵdirectiveInject(i7.ToastrService)); };
AddBeneficiaryOrMemberComponent.ɵcmp = i0.ɵɵdefineComponent({ type: AddBeneficiaryOrMemberComponent, selectors: [["lib-add-beneficiary-or-member"]], outputs: { onSaveComplete: "onSaveComplete" }, decls: 40, vars: 8, consts: [[1, "container-fuild"], [1, "p-grid", "pt-2"], [1, "p-col-7", "align-middle"], [4, "ngIf"], [1, "p-col-5", "text-right", "align-middle"], [1, "close-icon", "pi", "pi-times", 3, "click"], [1, "mt-0", "mb-1"], [1, "p-col-12", "p-0"], [3, "formGroup"], [1, "main-body"], [1, "p-fluid", "p-formgrid", "p-grid", "pt-2"], [1, "p-col-4", "pb-3"], ["id", "firstNameLabel", 1, "label-cls", "required", "common-bene-class-for-translation"], ["id", "firstName", "formControlName", "fName", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100", "common-bene-class-for-translation"], ["id", "lastNameLabel", 1, "label-cls", "required", "common-bene-class-for-translation"], ["id", "lastName", "formControlName", "lName", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100", "common-bene-class-for-translation"], ["id", "middleNameLabel", 1, "label-cls", "common-bene-class-for-translation"], ["id", "middleName", "formControlName", "mName", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100", "common-bene-class-for-translation"], ["formArrayName", "emailContacts", 1, "p-col-4", "pb-3"], ["id", "emailLabel", 1, "label-cls", "required", "common-bene-class-for-translation"], [4, "ngFor", "ngForOf"], ["class", "p-col-4 pb-3", 4, "ngIf"], [1, "separator", "my-1"], [1, "p-0", "pt-2", "pb-2", "d-flex"], [1, "text-left", "m-0", "w-100"], ["pButton", "", "type", "button", "title", "SELECT", "id", "saveButton", 3, "disabled", "click"], [1, "common-bene-class-for-translation"], ["pButton", "", "type", "button", "title", "CANCEL", "id", "cancelButton", 1, "p-button-secondary", "ml-3", 3, "click"], ["class", "mb-0 common-bene-class-for-translation", "id", "addSponsorHeader", 4, "ngIf"], ["class", "mb-0 common-bene-class-for-translation", "id", "addIndividualHeader", 4, "ngIf"], ["id", "addSponsorHeader", 1, "mb-0", "common-bene-class-for-translation"], ["id", "addIndividualHeader", 1, "mb-0", "common-bene-class-for-translation"], ["id", "addDependentHeader", 1, "mb-0", "common-bene-class-for-translation"], ["class", "invalid-message common-bene-class-for-translation", "id", "requiredError", 4, "ngIf"], ["id", "requiredError", 1, "invalid-message", "common-bene-class-for-translation"], [3, "formGroupName"], ["type", "text", "formControlName", "email", "placeholder", "Enter", 1, "im-input", "common-bene-class-for-translation", 3, "id", "pattern"], ["class", "invalid-message common-bene-class-for-translation", 3, "id", 4, "ngIf"], [1, "invalid-message", "common-bene-class-for-translation", 3, "id"], ["id", "relationshipLabel", 1, "label-cls", "required", "common-bene-class-for-translation"], ["id", "relationshipDropdown", "inputId", "relationShipType", "formControlName", "relationShipType", "name", "relationShipType", "optionLabel", "name", "placeholder", "Select Relationship", "appendTo", "body", "optionDisabled", "inactive", 1, "w-100", 3, "options"]], template: function AddBeneficiaryOrMemberComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtemplate(3, AddBeneficiaryOrMemberComponent_div_3_Template, 3, 2, "div", 3);
        i0.ɵɵtemplate(4, AddBeneficiaryOrMemberComponent_div_4_Template, 3, 0, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵelementStart(6, "i", 5);
        i0.ɵɵlistener("click", function AddBeneficiaryOrMemberComponent_Template_i_click_6_listener() { return ctx.handleClose(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(7, "hr", 6);
        i0.ɵɵelementStart(8, "div", 7);
        i0.ɵɵelementStart(9, "form", 8);
        i0.ɵɵelementStart(10, "div", 9);
        i0.ɵɵelementStart(11, "div", 10);
        i0.ɵɵelementStart(12, "div", 11);
        i0.ɵɵelementStart(13, "label", 12);
        i0.ɵɵtext(14, " First Name ");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(15, "input", 13);
        i0.ɵɵtemplate(16, AddBeneficiaryOrMemberComponent_div_16_Template, 2, 1, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "div", 11);
        i0.ɵɵelementStart(18, "label", 14);
        i0.ɵɵtext(19, " Last Name ");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(20, "input", 15);
        i0.ɵɵtemplate(21, AddBeneficiaryOrMemberComponent_div_21_Template, 2, 1, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "div", 11);
        i0.ɵɵelementStart(23, "label", 16);
        i0.ɵɵtext(24, " Middle Name (Optional) ");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(25, "input", 17);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(26, "div", 18);
        i0.ɵɵelementStart(27, "label", 19);
        i0.ɵɵtext(28, " Email ");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(29, AddBeneficiaryOrMemberComponent_ng_container_29_Template, 5, 5, "ng-container", 20);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(30, AddBeneficiaryOrMemberComponent_div_30_Template, 5, 2, "div", 21);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(31, "hr", 22);
        i0.ɵɵelementStart(32, "div", 23);
        i0.ɵɵelementStart(33, "div", 24);
        i0.ɵɵelementStart(34, "button", 25);
        i0.ɵɵlistener("click", function AddBeneficiaryOrMemberComponent_Template_button_click_34_listener() { return ctx.saveBenMember(); });
        i0.ɵɵelementStart(35, "span", 26);
        i0.ɵɵtext(36, "SAVE");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(37, "button", 27);
        i0.ɵɵlistener("click", function AddBeneficiaryOrMemberComponent_Template_button_click_37_listener() { return ctx.handleClose(); });
        i0.ɵɵelementStart(38, "span", 26);
        i0.ɵɵtext(39, "CANCEL");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", !ctx.inputData.isBeneficiaryInitiated);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.inputData.isBeneficiaryInitiated);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("formGroup", ctx.addBenMemberForm);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngIf", ctx.addBenMemberForm.get("fName").touched && ctx.addBenMemberForm.get("fName").invalid);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.addBenMemberForm.get("lName").touched && ctx.addBenMemberForm.get("lName").invalid);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("ngForOf", ctx.addBenMemberForm.get("emailContacts")["controls"]);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.inputData.isAddingMember);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("disabled", !ctx.addBenMemberForm.valid);
    } }, directives: [i8.NgIf, i2.ɵangular_packages_forms_forms_ba, i2.NgControlStatusGroup, i2.FormGroupDirective, i2.DefaultValueAccessor, i2.NgControlStatus, i2.FormControlName, i9.InputText, i2.FormArrayName, i8.NgForOf, i10.ButtonDirective, i2.FormGroupName, i2.PatternValidator, i11.Dropdown], styles: [".main-body[_ngcontent-%COMP%]{height:calc(60vh - 116px);width:100%;overflow:auto;padding-right:10px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddBeneficiaryOrMemberComponent, [{
        type: Component,
        args: [{
                selector: 'lib-add-beneficiary-or-member',
                templateUrl: 'add-beneficiary-or-member.component.html',
                styleUrls: ['add-beneficiary-or-member.component.scss']
            }]
    }], function () { return [{ type: i1$1.ReferenceLibraryService }, { type: i2.FormBuilder }, { type: i3.DynamicDialogRef }, { type: i3.DynamicDialogConfig }, { type: i4.Store }, { type: i5.DirtyFormGuard }, { type: AddBeneficiaryOrMemberService }, { type: i7.ToastrService }]; }, { onSaveComplete: [{
            type: Output
        }] }); })();

class AddBeneficiaryOrMemberModule {
}
AddBeneficiaryOrMemberModule.ɵfac = function AddBeneficiaryOrMemberModule_Factory(t) { return new (t || AddBeneficiaryOrMemberModule)(); };
AddBeneficiaryOrMemberModule.ɵmod = i0.ɵɵdefineNgModule({ type: AddBeneficiaryOrMemberModule });
AddBeneficiaryOrMemberModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            ButtonModule,
            DropdownModule,
            InputTextModule,
            DividerModule,
            DynamicDialogModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(AddBeneficiaryOrMemberModule, { declarations: [AddBeneficiaryOrMemberComponent], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ButtonModule,
        DropdownModule,
        InputTextModule,
        DividerModule,
        DynamicDialogModule], exports: [AddBeneficiaryOrMemberComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddBeneficiaryOrMemberModule, [{
        type: NgModule,
        args: [{
                declarations: [AddBeneficiaryOrMemberComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    ButtonModule,
                    DropdownModule,
                    InputTextModule,
                    DividerModule,
                    DynamicDialogModule
                ],
                exports: [AddBeneficiaryOrMemberComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of add-beneficiary-or-member
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AddBeneficiaryOrMemberComponent, AddBeneficiaryOrMemberModule, AddBeneficiaryOrMemberService };
//# sourceMappingURL=add-beneficiary-or-member.js.map
